import { render } from "./Line2slots.vue?vue&type=template&id=5ed2f89c&scoped=true"
import script from "./Line2slots.vue?vue&type=script&lang=js"
export * from "./Line2slots.vue?vue&type=script&lang=js"

import "./Line2slots.vue?vue&type=style&index=0&id=5ed2f89c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed2f89c"]])

export default __exports__